<template>
  <tbody :class="openHistory?'openHistory':''" v-for="(item,index) in prescriptionInfoList" :key="index" @mouseover="changeShowBtn(item)">
    <tr>
      <th rowspan="2" style="text-align: center;" class="thBox">
        处方{{index+1}}
        <!-- {{data.status}} -->
        <p style="font-size:10px;color:#FF4500">*该字体颜色为药房无此药品(发送处方时，该药品会删除，不会参加计费！)</p>
        <div v-if="data.status=='Diagnosing'">
          <a-button v-if="item.showPrescribeBtn" size="samll" @click="prescribe(item,index)" style="margin:10px;">开药</a-button>
          <a-popconfirm title="是否确认删除" @confirm="deletePrescription(item)" okText="确认" cancelText="取消">
            <a-button v-if="item.showPrescribeBtn" size="samll" type="primary" style="margin:10px;">删除</a-button>
          </a-popconfirm>
        </div>
      </th>
      <td colspan="2">
        <div class="medicalList">
          <div v-for="item2 in item.items" key="item2.id">
            <p :class="item2.productId?'':'orange'">{{item2?.name?item2.name:"？"}}：</p>
            <a-input-number v-if="data.status=='Diagnosing'" v-model:value="item2.quantity" style="width: 75px;" @change="changeMedical(item2.id,item2.quantity)" />
            <div class="number" v-else>{{item2.quantity}}</div>
            <a-popconfirm v-if="data.status=='Diagnosing'" title="是否确认删除" @confirm="deleteMedical(item2.id)" okText="确认" cancelText="取消">
              <CloseCircleOutlined style="color:red" />
            </a-popconfirm>
          </div>
        </div>
        <div v-if="item.editMedicalList&&data.status=='Diagnosing'">
          <a-select v-model:value="medical.name" :ref="'select'+index" show-search placeholder="中文或首字母" allowClear :filterOption="filterName" size="small" style="width: 180px;" @change="toInputs(index)">
            <a-select-option v-for="item in medicineOption" :value="item.name">{{ item.name }}{{item.standardName==item.name ||!item.standardName?"":"("+item.standardName+")"}}</a-select-option>
          </a-select>
          <a-input-number size="small" :ref="'input'+index" v-model:value="medical.quantity" style="width:200px;margin-left: 10px;" @pressEnter="handlePrescribe(item,index)" />
          <a-button :disabled="!medical.name||!medical.quantity" type="primary" size="small" @click="handlePrescribe(item,index)" style="margin-left:10px;">添加</a-button>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div style="display: flex;">
          <div class="inputsBox">
            <span>药量：</span>
            <a-input-number v-if="data.status=='Diagnosing'" size="small" :class="item.dosageDays?'ant-input2':'ant-input2 warning'" v-model:value="item.dosageDays" @change="changePrescription(item)" style="margin-right: 10px;" />
            <div v-else class="readOnly">{{item.dosageDays}}</div>
          </div>
          <div class="inputsBox">
            <span>用量(次/天)：</span>
            <a-input-number v-if="data.status=='Diagnosing'" size="small" :class="item.timesPerDay?'ant-input2':'ant-input2 warning'" v-model:value="item.timesPerDay" @change="changePrescription(item)" />
            <div v-else class="readOnly">{{item.timesPerDay}}</div>
          </div>
        </div>
        <div style="display: flex;">
          <div class="inputsBox">
            <span>使用方法：</span>
            <div v-if="data.status!='Diagnosing'" class="readOnly">{{item.takingMethod}}</div>
            <span v-else-if="template=='Simple_Futie'">{{item.takingMethod}}</span>
            <a-select v-else v-model:value="item.takingMethod" show-search placeholder="中文或首字母" allowClear :filterOption="filterName" size="small" :class="item.takingMethod?'ant-input2':'ant-input2 warning'" @change="changePrescription(item)">
              <a-select-option v-for="item2 in item.takingMethodOption" :value="item2">{{ item2}}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="inputsBox">
          <span>描述</span>
          <a-textarea v-if="data.status=='Diagnosing'" size="small" class="ant-input2" :autosize="true" style="min-height:60px !important;width:75%" v-model:value="item.description" @change="changePrescription(item)" />
          <div v-else class="readOnly">{{item.description}}</div>
        </div>
      </td>
    </tr>
  </tbody>

</template>

<style scoped>
.report {
}

.report .table {
  height: 82vh;
  overflow: auto;
  width: 60%;
  margin: 0 auto;
  transition: 0.5s all;
}

.purple {
  color: #ff00ff;
}

.orange {
  color: #ff4500;
}

.openHistory .table table {
  width: 100%;
}
textarea {
  resize: none;
}

.head {
  text-align: center;
  position: fixed;
  width: 100%;
  z-index: 9;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}

.table .row {
  display: flex;
  vertical-align: middle;
  align-items: center;
}
.openHistory .medicalList > div {
  width: 33.333%;
}
table {
  /* width: 75%; */
  margin: 0 auto;
  border-color: #aaa;
  text-align: left;
}

tr {
  height: 40px;
}

tr:hover {
  background-color: #fff8e3;
}

th,
td {
  padding: 5px;
}

th {
  text-align: center;
  width: 250px;
}

.bg-light {
  background-color: #fcf8e3;
}

.ant-input {
  display: inline-block;
}

.bg-light .ant-input {
  border: none;
  background-color: #fcf8e3;
}

.ant-select {
  width: 250px;
}
.number {
  display: inline;
}
.readOnly {
  display: inline-block;
  width: 200px;
}
.block {
  display: block;
  margin: 0 auto 5px;
}

.buttonBox {
  position: fixed;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
}
.buttonBox .ant-btn {
  margin: 10px 10px;
}
.popconfirm {
  position: relative;
  display: inline-block;
}
.popconfirm .box {
  position: absolute;
  top: 100%;
  left: 50%;
  background-color: #f1fdff;
  transform: translate(-50%, 7px);
  border: 1px solid #ccc;
  padding: 10px;
  width: 300px;
  z-index: 10;
  box-shadow: 3px 3px 7px #00000052;
  border-radius: 10px;
}
/* popconfirm面的小三角 */
.popconfirm .box::after {
  content: "";
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -100%);
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent #ccc transparent;
}
.popconfirm .box h5 {
  border-bottom: 1px solid #999;
  padding-bottom: 8px;
  font-size: 16px;
  text-align: center;
  letter-spacing: 3px;
}
.popconfirm .box .content {
  margin-bottom: 10px;
}
.popconfirm .box .content > * {
  margin-bottom: 5px;
}

.popconfirm .btnBox {
  display: flex;
  justify-content: center;
}

.popconfirm .btnBox .ant-btn {
  margin-left: 10px;
}
.btns .ant-btn {
  margin-right: 5px;
}
.list .item {
  position: relative;
}
.list .item > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 28px;
  position: relative;
  padding: 2px 0px 2px 15px;
  cursor: pointer;
}
.list .item .anticon {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  z-index: 1;
}
.list .item .anticon-close-circle {
  display: none;
  position: absolute;
}
.list .item:hover .anticon-close-circle {
  display: inline;
}
.list .item .anticon-close-circle:hover + div {
  color: red;
}

.list .item > div > * {
  margin: 0;
  margin-right: 10px;
}

.inputsBox {
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-top: 10px;
  margin-right: 10px;
}

.inputsBox span {
  display: inline-block;
  width: 100px;
}
.inputsBox .warning {
  background-color: #fcf8e3;
}

.ant-inputs2 {
  width: 100px;
  text-align: center;
}

.medicalList {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
}
.medicalList > div {
  width: 25%;
  margin: 5px 0;
}
.medicalList p {
  display: inline-block;
  width: 100px;
  font-size: 12px;
  text-align: right;
  margin-bottom: 0;
}

.medicalList span {
  display: none;
  margin-left: 15px;
}
.medicalList > div:hover span {
  display: inline-block;
}
.ant-input2 {
  width: 200px;
}
</style>



<script>
import {
  CloseCircleOutlined,
  CheckCircleOutlined
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep, } from "lodash-es";
import { RecordDetail, CustomerDetail, Save, SyndromeList, DiseaseList, AddReportItem, GetSetting, GetOperation, Send, GetReportDetail, UpdateSyndromeList, DeleteList, GetPulse, GetPrescriptionList, GetMedicineOption, AddMedical, UpdateMedical, DeleteMedical, UpdatePrescription, GetTakingMethods, AddPrescription, DeletePrescription, RecordList, RecordCopy } from "/src/api/medicalRecord.js";
import { pinyin } from 'pinyin-pro';
import editCustomer from "/src/components/medicalRecord/editCustomer.vue";
export default {
  components: {
    editCustomer,
    CloseCircleOutlined
  },
  name: "病历",
  data() {
    return {
      saveTimeout: null,
      medical: {
        id: undefined,
        quantity: undefined,
      },
    };
  },
  props: {
    prescriptionInfoList: {
      type: Array,
      default: () => []
    },
    openHistory: {
      type: Boolean,
      default: false
    },
    template: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({})
    },
  },
  created() { },
  mounted() {
    this.init()
  },
  activated() {

  },
  methods: {
    async init() {
      // if (this.template == "Simple_Futie") {
      // }
    },
    changeShowBtn(item) {
      this.prescriptionInfoList.forEach(item => {
        item.showPrescribeBtn = false
      })
      item.showPrescribeBtn = true
    },
    async changeMedical(id, quantity) {
      console.log(id, quantity);
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(async () => {
        let res = await UpdateMedical({ id, quantity })
        if (res.errCode != 0) {
          this.$message.error("修改失败")
        } else {
          this.$message.success("修改成功")
        }
      }, 500)
    },
    //开药
    async prescribe(item, index) {
      console.log(item);
      this.prescriptionInfoList.forEach(item => {
        item.editMedicalList = false
      })
      this.prescriptionInfoList[index].editMedicalList = true
      this.getMedicineOption(item.id)

      await this.$nextTick(() => {
        this.$refs["select" + index][0].focus()
        // this.$refs["input" + index][0].focus()
      })
      this.medical = {
        id: undefined,
        quantity: undefined,
      }
    },
    getPinyinFirstInitials(str) {
      if (!str) return '';

      const result = pinyin(str, {
        pattern: 'first',   // 只获取拼音首字母
        toneType: 'none',      // 不要音调
        mode: 'normal',   // 普通模式（非智能分词）
      });

      // 处理返回结果（兼容数组和字符串两种结构）
      if (Array.isArray(result)) {
        return result.map(arr => arr[0]).join('').toLowerCase();
      } else if (typeof result === 'string') {
        return result.replace(/\s+/g, '').toLowerCase(); // 去空格
      }

      return '';
    },
    getPinyinInitials(str) {
      if (!str) return '';

      const result = pinyin(str, {
        toneType: 'none',      // 不要音调
        mode: 'normal',   // 普通模式（非智能分词）
      });

      // 处理返回结果（兼容数组和字符串两种结构）
      if (Array.isArray(result)) {
        return result.map(arr => arr[0]).join('').toLowerCase();
      } else if (typeof result === 'string') {
        return result.replace(/\s+/g, '').toLowerCase(); // 去空格
      }
      return '';
    },
    filterName(input, option) {
      // console.log(option);
      const label = option.value; // a-select-option 的显示文本
      const pinyinFirstInitials = this.getPinyinFirstInitials(label); // 获取该选项的拼音首字母
      const pinyinInitials = this.getPinyinInitials(label); // 获取该选项的拼音首字母
      const lowerInput = input.toLowerCase(); // 输入内容统一小写处理
      // console.log(pinyinInitials);

      // 匹配中文 或 拼音首字母
      return (
        label.toLowerCase().includes(lowerInput) ||
        pinyinFirstInitials.toLowerCase().includes(lowerInput) ||
        pinyinInitials.toLowerCase().includes(lowerInput)
      );
    },

    async getMedicineOption(id) {
      let medicineOption = await GetMedicineOption({ pageSize: -1, id });
      this.medicineOption = medicineOption.data
      // console.log("medicineOption", medicineOption);

    },
    toInputs(index) {
      this.$nextTick(() => {
        this.$refs["input" + index][0].focus()
      })
    },
    async deleteMedical(id) {
      let res = await DeleteMedical({ id })
      if (res.errCode == 0) {
        this.$emit("getPrescriptionList")
      }
    },

    async handlePrescribe(item, index) {
      // console.log(this.medicineOption);
      //找到这个药的id
      let medicineId = this.medicineOption.find(item => item.name == this.medical.name).medicineId
      console.log("medicineId", medicineId);

      //判断列表中是否有这个药
      let prescriptionInfoItem = this.prescriptionInfoList[index]?.items?.find(item => item.medicineId == medicineId)
      if (prescriptionInfoItem) {
        prescriptionInfoItem.quantity = this.medical.quantity
      }
      let obj = this.medicineOption.find(item => item.name == this.medical.name)
      let parmas = { prescriptionId: item.id, medicineId: obj.medicineId, name: obj.name, productId: obj.id, quantity: this.medical.quantity }
      let res = await AddMedical(parmas)
      console.log("AddMedical", res);
      if (!this.prescriptionInfoList[index]?.items) {
        this.prescriptionInfoList[index].items = []
      }
      if (res.errCode == 0) {
        if (!prescriptionInfoItem) {
          this.prescriptionInfoList[index].items.push(res.data)
        }
        this.prescriptionInfoList[index].editMedicalList = true

        console.log("this.medical", this.medical);

        await this.$nextTick(() => {
          this.$refs["select" + index][0].focus()
          // this.$refs["input" + index][0].focus()
        })
        this.medical = {
          id: undefined,
          quantity: undefined,
        }
        // setTimeout(() => {

        // }, 200);
      }

    },
    async deletePrescription(item) {
      let res = await DeletePrescription({ id: item.id })
      if (res.errCode == 0) {
        this.$emit("getPrescriptionList")
      } else {
        this.$message.error("删除失败")
      }
    },
    async changePrescription(item) {

      clearTimeout(this.saveTimeout);
      let parmas = {
        id: item.id,
        dosageDays: item.dosageDays,
        timesPerDay: item.timesPerDay,
        takingMethod: item.takingMethod,
        description: item.description,
      }

      // parmas[type] = value
      this.saveTimeout = setTimeout(async () => {
        let res = await UpdatePrescription(parmas)
        if (res.errCode != 0) {
          this.$message.error("修改失败")
        }
      }, 500)
    },
  },
  watch: {
    prescriptionInfoList(val) {

      this.$emit('update:prescriptionInfoList', val);
    },
  },
};
</script>


